import { useEffect } from "react";

/**
 * Hook que dispara `onOutside` cuando el usuario hace click fuera de TODOS los refs provistos.
 * Se ignora si `enabled` es `false`.
 */
export const useClickOutside = (
  refs: React.RefObject<HTMLElement>[],
  onOutside: (e: MouseEvent) => void,
  enabled: boolean = true
) => {
  useEffect(() => {
    if (!enabled) return;

    const listener = (e: MouseEvent) => {
      // Si el click ocurre dentro de alguno de los refs, no hacemos nada
      const clickInside = refs.some(ref => ref.current?.contains(e.target as Node));
      if (clickInside) return;
      onOutside(e);
    };

    document.addEventListener("mousedown", listener, true);
    return () => document.removeEventListener("mousedown", listener, true);
  }, [enabled, ...refs, onOutside]);
};
